import Vue from "vue";
import VueRouter from "vue-router";
import { RouterTabRoutes } from "vue-router-tab";

import Home from "../views/Home.vue";
import Blog from "../views/Blog.vue";
import BlogDetails from "../views/BlogDetail.vue";
import Calculator from "../components/calculator";
// import JobInfo from "../components/registrations/JobInfo.vue";
import Login from "../views/registration/Login";
import Signup from "../views/registration/Signup";
import OtpCode from "../views/registration/OtpCode";
import ForgotPassOtp from "../views/registration/ForgotPassOtp";
import SetNewPassOtp from "../views/registration/SetNewpassOtp";
import SupplierItems from "../views/registration/SupplierItems.vue"
// import Register from '../components/userDashboard/Register'
//import Register from '../views/registration/RegisterForm'
import BaseRegister from "../views/registration/BaseRegister";
import User from "../views/UserApp";
import UploadUserDocs from "../components/userDashboard/UploadUserDocuments";
import SetLevel from "../components/userDashboard/SetLevel";
import SetCostumerData from "../components/userDashboard/SetCostumerData";
//import CostumerShowPage from "../components/userDashboard/CostomerShowPage";
import IdentityInfo from "../components/userDashboard/IdentityInfo";
import ResidentialInfo from "../components/userDashboard/ResidentialInfo";
import UserStatus from '../components/userDashboard/UserStatus'
import SetFirstSurtyData from "../components/userDashboard/SetFirstSurtyData";
import SetSecondSurtyData from "../components/userDashboard/SetSecondSurtyData";
// import UploadFirstSurtyDocs from "../components/userDashboard/UploadFirstSurtyDocs";
// import UploadSecondSurtyDocs from "../components/userDashboard/UploadSecondSurtyDocs";
import InnerPages from "../views/InnerPages";
import Faq from "../components/innerpages/Faq";
import AboutUs from "../components/innerpages/AboutUs";
import ContactUs from "../components/innerpages/ContactUs";
import HowToSignup from "../components/innerpages/HowToSignup";

//import Edit from "../views/registration/EditForm";
import ContractsList from "../components/userDashboard/ContractsList";
import ContractDetail from "../components/userDashboard/ContractDetail";
//  -------------------- Success -------------------------------
import SuccessCustomerDocs from "../components/success/SuccessCustomerDocs";
import SuccessSurtyDocs from "../components/success/SuccessSurtyDocs";
import SupplierSuccess from "../components/success/SupplierSuccess";
import ResetPassSuccess from "../components/success/ResetPassSuccess";

//==----------supplier--------
import SupplierApp from "../views/SupplierApp";
import SupplierShowCustomers from "../components/supplierPanel/SupplierShowCustomers.vue";
import SuppliersCustomer from "../components/supplierPanel/SupplierCustomer.vue";
//import SupplierEditCustomerIdentityInfo from "../components/supplierPanel/SupplierEditCustomerIdentityInfo.vue";
import SuppliersCustomerDetail from "../components/supplierPanel/SuppliersCustomerDetail.vue";
import SuppliersCustomerEdit from "../components/supplierPanel/SuppliersCustomerEdit.vue";
import SuppliersCustomerFirstSurety from "../components/supplierPanel/SuppliersCustomerFirstSurety.vue";
import SuppliersCustomerSecondSurety from "../components/supplierPanel/SuppliersCustomerSecondSurety.vue";
//import SuppliersCustomerSetLevel from "../components/supplierPanel/SuppliersCustomerSetLevel.vue";
import SuppliersCustomerContracts from "../components/supplierPanel/SuppliersCustomerContracts.vue";
import SuppliersCustomerContractDetail from "../components/supplierPanel/SuppliersCustomerContractDetail.vue";
import SuppliersCustomerDocs from "../components/supplierPanel/SuppliersCustomerDocs.vue";
// import SupplierCreateCustomer from '../components/supplierPanel/SupplierCreateCustomer.vue'
import SuppliersCustomerFirstSuretyDocs from "../components/supplierPanel/SuppliersCustomerFirstSuretyDocs.vue";
import SuppliersCustomerSecondSuretyDocs from "../components/supplierPanel/SuppliersCustomerSecondSuretyDocs.vue";
import SupplierAddContract from "../components/supplierPanel/SupplierAddContract.vue";
import SupplierContracts from "../components/supplierPanel/SupplierContracts.vue";

import supplierInstalments from "../components/supplierPanel/SupplierCustomerInstalmentNoteBook.vue";
import supplierPayments from "../components/supplierPanel/SupplierCustomerPaymentNoteBook.vue";

import instalments from "../components/userDashboard/CustomerInstalmentNoteBook.vue";
import payments from "../components/userDashboard/CustomerPaymentNoteBook.vue";

import LoginSupplier from "../views/registration/LoginSupplier";
import SupplierRegister from "../views/registration/SupplierRegister";
import HowToSupplierSignup from "../components/innerpages/HowToSupplierSignUp";

import SupplierCustomerSignup from "../components/supplierPanel/SupplierCustomerSignup.vue";
import SupplierCustomerCheckOtp from "../components/supplierPanel/SupplierCustomerCheckOtp.vue";
import SupplierCustomerBaseRegister from "../components/supplierPanel/SupplierCustomerBaseRegister.vue";
import SupplierCustomrData from "../components/supplierPanel/SupplierCustomrData.vue";
import EditIdentityInfo from "../views/EditIdentityInfo.vue";
import EditSetLevel from "../views/EditSetLevel.vue";
import EditResidentialInfo from "../views/EditResidentialInfo.vue";
import EditJobInfo from "../views/EditJobInfo.vue";
import IceIdentification from "../components/IceIdentification.vue";

// import Test from '../components/userDashboard/UploadTest'

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "home",
		component: Home,
	},
	// {
	//   path: '/home',
	//   name: 'home',
	//   // route level code-splitting
	//   // this generates a separate chunk (about.[hash].js) for this route
	//   // which is lazy-loaded when the route is visited.
	//   // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
	//   component: Home
	// },

	{
		path: "/test",
		name: "test",
		component: () => import("../views/registration/NewRegisteration.vue"),
		children: [
			{
				path: "identitiy",
				name: "identitiy",
				// beforeEnter: (to, from, next) => {
				// 	if (from.name == "otp") next();
				// 	else next({ name: "signUp" });
				// },
				component: () => import("../components/registrations/IdentityInfo.vue"),
			},
			{
				path: "residential",
				name: "residential",
				component: () =>
					import("../components/registrations/ResidentialInfo.vue"),
			},
			{
				path: "job",
				name: "job",
				component: () => import("../components/registrations/JobInfo.vue"),
			},
			{
				path: "level",
				name: "level",
				component: () => import("../components/registrations/SetLevel.vue"),
			},
			
		],
	},
	{
		path: "/registerpage",
		name: "registerPage",
		component: () => import("../views/registration/Registers.vue"),
	},
	{
		path: "/newlogin",
		name: "test",
		component: () => import("../views/registration/NewLoginView.vue"),
		children: [
			{
				path: "",
				name: "login",
				component: () => import("../components/registrations/Login.vue"),
			},
			{
				path: "/newregister",
				name: "signUp",
				meta:{title:"salam"},
				component: () => import("../components/registrations/NewSignUp.vue"),
			},
			{
				path: "/newotp",
				name: "otp",
				beforeEnter: (to, from, next) => {
					console.log("---------------------------------from.name: "+from.name)
					if (from.name == "signUp" || from.name=="supplierCustomerSignUp") next();
					else next({ name: "signUp" });
				},
				props:true,
				component: () => import("../components/registrations/NewOtp.vue"),
			},
			{
				path: "/new-forgat-page",
				name: "forgatPass",
				// beforeEnter: (to, from, next) => {
				// 	if (from.name == "signUp") next();
				// 	else next({ name: "signUp" });
				// },
				component: () => import("../components/registrations/NewForgotPass.vue"),
			},
		],
	},
	{
		path: "/blog",
		name: "blog",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		// component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
		component: Blog,
	},
	{
		path: "/blog/:id",
		name: "blog-details",
		component: BlogDetails,
	},
	{
		path: "/calc",
		name: "calculator",
		component: Calculator,
	},
	{
		path: "/",
		name: "innerpages",
		component: InnerPages,
		children: [
			{
				path: "/about-us",
				component: AboutUs,
			},
			{
				path: "/faq",
				component: Faq,
			},
			{
				path: "/contact-us",
				name: "contact-us",
				component: ContactUs,
			},
			{
				path: "/how-to-signup",
				name: "HowToSignup",
				component: HowToSignup,
			},
			{
				path: "/how-to-signup",
				name: "HowToSignup",
				component: HowToSignup,
			},
			{
				path: "/how-to-supplier-signup",
				name: "HowToSupplierSignup",
				component: HowToSupplierSignup,
			},
		],
	},
	{
		path: "/customer",
		name: "customer",
		component: User,
		children: [
			{
				path: "",
				name: "IdentityInfo",
				component: IdentityInfo,
			},
			{
				path: "userStatus",
				name: "userStatus",
				component: UserStatus,
			},

			{
				path:"identityInfo",
				name:"IdentityInfo",
				component:IdentityInfo
			},
			{
				path:"residentialInfo",
				name:"residentialInfo",
				component:ResidentialInfo



			},
			{
				path: "upload-user-docs",
				name: "upload-user-docs",
				component: UploadUserDocs,
			},
			{
				path: "set-level",
				name: "setlevel",
				component: SetLevel,
			},
			{
				path: "setTheLevel",
				name: "setTheLevel",
				component:EditSetLevel,
			},
			{
				path: "customer-data",
				name: "customerData",
				component: SetCostumerData,
			},
			{
				path: "editIdentityInfo",
				name: "editIdentityInfo",
				component:EditIdentityInfo
			},
			{
				path: "editResidentialInfo",
				name: "editResidentialInfo",
				component: EditResidentialInfo,
			},
			{
				path: "editJobInfo",
				name: "editJobInfo",
				component: EditJobInfo,
			},
			{
				path:"firstSuretyIdentityInfo",
				name:"firstSuretyIdentityInfo",
				component:EditIdentityInfo
			},
			
			{
				path:"firstSuretyJobInfo",
				name:"firstSuretyJobInfo",
				component:EditJobInfo
			},
			{
				path:"firstSuretyResidentialInfo",
				name:"firstSuretyResidentialInfo",
				component:EditResidentialInfo
			},
			{
				path:"secondSuretyIdentityInfo",
				name:"secondSuretyIdentityInfo",
				component:EditIdentityInfo
			},
			
			{
				path:"secondSuretyJobInfo",
				name:"secondSuretyJobInfo",
				component:EditJobInfo
			},
			{
				path:"secondSuretyResidentialInfo",
				name:"secondSuretyResidentialInfo",
				component:EditResidentialInfo
			},
			{
				path: "first-surety-data",
				name: "firstsuretyData",
				component: SetFirstSurtyData,
			},
			{
				path: "second-surety-data",
				name: "secondsuretyData",
				component: SetSecondSurtyData,
			},
			{
				path: "upload-first-surty-docs",
				name: "upload-first-surty-docs",
				component: UploadUserDocs,
			},
			{
				path: "upload-second-surty-docs",
				name: "upload-second-surty-docs",
				component: UploadUserDocs,
			},
			{
				path: "success-customer-doc",
				component: SuccessCustomerDocs,
			},
			{
				path: "success-surty-doc",
				component: SuccessSurtyDocs,
			},
			{
				path: "contracts",
				component: ContractsList,
			},
			{
				path: "contract-detail/:id",
				component: ContractDetail,
				props: true,
			},
			{
				path: "payments/:id",
				component: payments,
				props: true,
			},
			{
				path: "instalments/:id",
				component: instalments,
				props: true,
			},
			{
				path: "identification",
				component: IceIdentification,
			},
		],
	},
	{
		path: "/login",
		name: "login",
		component: Login,
	},
	{
		path: "/sign-up",
		name: "sign-up",
		component: Signup,
	},
	{
		path: "/supplier-register",
		name: "SupplierRegister",
		component: SupplierRegister,
	},
	{
		path: "/otp-code",
		name: "otp-code",
		component: OtpCode,
	},
	{
		path: "/forgot-pass",
		name: "forgot-pass",
		component: ForgotPassOtp,
	},
	{
		path: "/reset-pass-otp",
		name: "reset-pass-otp",
		component: SetNewPassOtp,
	},
	{
		path: "/base-register",
		name: "base-register",
		component: BaseRegister,
		// meta: {
		//   requiresAuth: true
		// }
	},
	{
		path:"/SupplierItems",
		name:"SupplierItems",
		component:SupplierItems,
	},
	{
		path: "/supplier",
		component: SupplierApp,
		children: [
			{
				path: "",
				name: "supplier",
				component: SupplierShowCustomers,
			},
			// {
			//   path:"create-customer",
			//   component:SupplierCreateCustomer
			// },
			{
				path: "customer-signup",
				name: "supplierCustomerSignUp",
				component: SupplierCustomerSignup,
			},
			{
				path: "otp-code",
				name: "SupplierCustomerOtpCode",
				component: SupplierCustomerCheckOtp,
				beforeEnter: (to, from, next) => {
					if (from.name !== "supplierCustomerSignUp") {
						next({
							name: "supplierCustomerSignUp",
						});
					} else {
						next();
					}
				},
			},
			{
				path: "customer-base-register",
				component: SupplierCustomerBaseRegister,
				beforeEnter: (to, from, next) => {
					if (from.name !== "SupplierCustomerOtpCode") {
						next({
							name: "supplierCustomerSignUp",
						});
					} else {
						next();
					}
				},
			},
			{
				path: "contracts",
				component: SupplierContracts,
				name:"supplierContracts"
			},
			{
				path: "customer-data/:id",
				props: true,
				component: SupplierCustomrData,
			},
			{
				path: "customers/:id",
				component: SuppliersCustomer,

				children: [
					...RouterTabRoutes,

					// SuppliersCustomerDetail
					{
						path: "",
						props: true,
						component: SuppliersCustomerDetail,
						meta: {
							title: " اطلاعات مشتری ", // tab title
							icon: "icon-user", // tab icon, optional
							tabClass: "custom-tab", // custom class, optional
							tips: "This is a tab", // tab tooltip, optional. defaults to `meta.title`
							// key: 'full-path', // tab cache rule, optional
							closable: false, // is tab closable, defaults to `true`
						},
					},
					// edit
					{
						path: "edit",
						name: "edit",
						
						props: true,
						component: SuppliersCustomerEdit,
						children:[
							{
								path:"",
								name:"SupplierEditCustomerIdentityInfo",
								component:EditIdentityInfo
							},
							{
								path:"SupplierEditCustomerResidentialInfo",
								name:"SupplierEditCustomerResidentialInfo",
								component:EditResidentialInfo
							},
							{
								path:"SupplierEditCustomerJobInfo",
								name:"SupplierEditCustomerJobInfo",
								component:EditJobInfo
							}
						],
						meta: {
							title: "ویرایش",
							icon: "icon-user", // tab icon, optional
							tabClass: "custom-tab", // custom class, optional
							tips: "This is a tab", // tab tooltip, optional. defaults to `meta.title`
							// key: 'full-path', // tab cache rule, optional
							closable: false, // is tab closable, defaults to `true`

						},
						
					},
					//  SuppliersCustomerDocs
					{
						path: "docs",
						props: true,
						component: SuppliersCustomerDocs,
						meta: {
							title: "مدارک متقاضی",
							icon: "icon-user", // tab icon, optional
							tabClass: "custom-tab", // custom class, optional
							tips: "This is a tab", // tab tooltip, optional. defaults to `meta.title`
							// key: 'full-path', // tab cache rule, optional
							closable: true, // is tab closable, defaults to `true`
						},
					},
					//  first-surety
					{
						path: "first-surety",
						props: true,
						// name:"SuppliersCustomerFirstSurety",
						redirect:{name:'SuppliersCustomerEditFirstSuretyIdentityInfo'},
						component: SuppliersCustomerFirstSurety,
						children:[
							{
							path:"",
							name:"SuppliersCustomerEditFirstSuretyIdentityInfo",
							component:EditIdentityInfo
							},
							// {
							// 	path:"EditIdentityInfo",
							// 	name:"SuppliersCustomerEditFirstSuretyIdentityInfo",
							// 	component:EditIdentityInfo
							// },
							{
							path:"EditResidentialInfo",
							name:"SuppliersCustomerEditFirstSuretyResidentialInfo",
							component:EditResidentialInfo
							},
							
							{
								path:"EditJobInfo",
								name:"SuppliersCustomerEditFirstSuretyJobInfo",
								component:EditJobInfo
							},
							
							{
								path:"EditSuppliersCustomerFirstSuretyDocs",
								name:"SuppliersCustomerFirstSuretyDocs",
								component:SuppliersCustomerFirstSuretyDocs
							},



						],
						meta: {
							title: "ضامن اول",
							icon: "icon-user", // tab icon, optional
							tabClass: "custom-tab", // custom class, optional
							tips: "This is a tab", // tab tooltip, optional. defaults to `meta.title`
							// key: 'full-path', // tab cache rule, optional
							closable: false, // is tab closable, defaults to `true`
						},
					},
					//   first-surety-docs
					{
						path: "first-surety-docs",
						name: "first-surety-docs",
						props: true,
						
						component: SuppliersCustomerFirstSuretyDocs,
						meta: {
							title: "مدارک ضامن اول",
							icon: "icon-user", // tab icon, optional
							tabClass: "custom-tab", // custom class, optional
							tips: "This is a tab", // tab tooltip, optional. defaults to `meta.title`
							// key: 'full-path', // tab cache rule, optional
							closable: true, // is tab closable, defaults to `true`
						},
					},
					// second-surety
					{
						path: "second-surety",
						props: true,
						component: SuppliersCustomerSecondSurety,
						children:[
							{
							path:"",
							name:"SuppliersCustomerEditSecondSuretyIdentityInfo",
							component:EditIdentityInfo
							},
							{
								path:"EditIdentityInfo",
								name:"SuppliersCustomerEditSecondSuretyIdentityInfo",
								component:EditIdentityInfo
							},
							{
							path:"EditResidentialInfo",
							name:"SuppliersCustomerEditSecondSuretyResidentialInfo",
							component:EditResidentialInfo
							},
							
							{
								path:"EditJobInfo",
								name:"SuppliersCustomerEditSecondSuretyJobInfo",
								component:EditJobInfo
							},
							{
								path:"SuppliersCustomerSecondSuretyDocs",
								name:"SuppliersCustomerSecondSuretyDocs",
								component:SuppliersCustomerSecondSuretyDocs
							}
								
						



						],
						meta: {
							title: "ضامن دوم",
							icon: "icon-user", // tab icon, optional
							tabClass: "custom-tab", // custom class, optional
							tips: "This is a tab", // tab tooltip, optional. defaults to `meta.title`
							// key: 'full-path', // tab cache rule, optional
							closable: false, // is tab closable, defaults to `true`
						},
					},
					//   second-surety-docs
					{
						path: "second-surety-docs",
						name: "second-surety-docs",
						props: true,
						component: SuppliersCustomerSecondSuretyDocs,
						meta: {
							title: "مدارک ضامن دوم",
							icon: "icon-user", // tab icon, optional
							tabClass: "custom-tab", // custom class, optional
							tips: "This is a tab", // tab tooltip, optional. defaults to `meta.title`
							// key: 'full-path', // tab cache rule, optional
							closable: true, // is tab closable, defaults to `true`
						},
					},
					//   set-level
					{
						path: "set-level",
						props: true,
						name:"supplierSetLevel",
						component: EditSetLevel,
						meta: {
							title: "حد اعتبار",
							icon: "icon-user", // tab icon, optional
							tabClass: "custom-tab", // custom class, optional
							tips: "This is a tab", // tab tooltip, optional. defaults to `meta.title`
							// key: 'full-path', // tab cache rule, optional
							closable: false, // is tab closable, defaults to `true`
						},
					},
					{
						path: "contract",
						props: true,
						component: SuppliersCustomerContracts,
						meta: {
							title: "قرارداد",
							icon: "icon-user", // tab icon, optional
							tabClass: "custom-tab", // custom class, optional
							tips: "This is a tab", // tab tooltip, optional. defaults to `meta.title`
							// key: 'full-path', // tab cache rule, optional
							closable: false, // is tab closable, defaults to `true`
						},
					},
					{
						path: "add-contract",
						props: true,
						component: SupplierAddContract,
						meta: {
							title: "ایجاد قرارداد",
							icon: "icon-user", // tab icon, optional
							tabClass: "custom-tab", // custom class, optional
							tips: "This is a tab", // tab tooltip, optional. defaults to `meta.title`
							// key: 'full-path', // tab cache rule, optional
							closable: true, // is tab closable, defaults to `true`
						},
					},
					//contract-detail
					{
						path: "contract-detail/:contract_id",
						props: true,
						component: SuppliersCustomerContractDetail,
						meta: {
							title: "جزییات قرارداد",
							icon: "icon-user", // tab icon, optional
							tabClass: "custom-tab", // custom class, optional
							tips: "This is a tab", // tab tooltip, optional. defaults to `meta.title`
							// key: 'full-path', // tab cache rule, optional
							closable: true, // is tab closable, defaults to `true`
						},
					},
					//instalments
					{
						path: "instalments/:contract_id",
						props: true,
						name: supplierInstalments,
						component: supplierInstalments, //'../components/supplierPanel/SupplierCustomrInstalmentsNoteBook.vue' ,
						meta: {
							title: "دفترچه اقساط",
							icon: "icon-user", // tab icon, optional
							tabClass: "custom-tab", // custom class, optional
							tips: "This is a tab", // tab tooltip, optional. defaults to `meta.title`
							key: "full-path", // tab cache rule, optional
							closable: true, // is tab closable, defaults to `true`
						},
					},
					//payments
					{
						path: "payments/:contract_id",
						props: true,
						component: supplierPayments, //'../components/supplierPanel/SupplierCustomrInstalmentsNoteBook.vue' ,
						meta: {
							title: "دفترچه پرداخت‌ها",
							icon: "icon-user", // tab icon, optional
							tabClass: "custom-tab", // custom class, optional
							tips: "This is a tab", // tab tooltip, optional. defaults to `meta.title`
							key: "full-path", // tab cache rule, optional
							closable: true, // is tab closable, defaults to `true`
						},
					},
				],
			},
		],
	},

	// {
	//   path: '/detail/:id',
	//   props: true,
	//   component:SuppliersCustomerDetail
	// },

	{
		path: "/login-supplier",
		name: "supplierLogin",
		component: LoginSupplier,
	},
	// {
	//   path: '/test',
	//   name: 'test',
	//   component: Test
	// },
	{
		path: "/supplier-success",
		component: SupplierSuccess,
	},

	{
		path: "/new-pass-success",
		component: ResetPassSuccess,
	},
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		}

		if (to.hash) {
			return {
				selector: to.hash,
			};
		} else {
			window.scrollTo(0, 0);
		}
	},
	routes,
});

// router.beforeEach(function (to, from, next) {
//   setTimeout(() => {
//     window.scrollTo(0, 0);
//   }, 100);
//   next();
// });

// router.beforeEach((to, from, next) => {
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     if (localStorage.getItem('jwt') == null) {
//       next({
//         path: '/login',
//         params: {
//           nextUrl: to.fullPath
//         }
//       })
//     } else {
//       let user = {
//         "is_admin": 0
//       } //JSON.parse(localStorage.getItem('user'))
//       if (to.matched.some(record => record.meta.is_admin)) {
//         if (user.is_admin == 1) {
//           next()
//         } else {
//           next({
//             name: 'userboard'
//           })
//         }
//       } else {
//         next()
//       }
//     }
//   } else if (to.matched.some(record => record.meta.guest)) {
//     if (localStorage.getItem('jwt') == null) {
//       next()
//     } else {
//       next({
//         name: 'userboard'
//       })
//     }
//   } else {
//     next()
//   }

// })

export default router;
